module.exports = __webpack_public_path__ + "static/media/Workshop_Implementacao_de_Microservices.47bac3d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Workshop_Implementacao_de_Microservices.png
// module id = 238
// module chunks = 0